// useReservationTimer.js
import { ref } from 'vue';
import api from "@/api/api";

const remainingTime = ref(null);

const fetchRemainingTime = async () => {
    try {
        const response = await api.get(`/get_remaining_time`);
        remainingTime.value = response.data.remaining_time;
    } catch (error) {
        console.error('Error fetching remaining time:', error);
    }
};

export default function useReservationTimer() {
    return { remainingTime, fetchRemainingTime };
}
